"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearPreparedExecution = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var errorHandling_1 = require("../../../utils/errorHandling");
var executionResult_1 = require("./executionResult");
var ExecutionConverter_1 = require("../../../convertors/toBackend/afm/ExecutionConverter");
var BearPreparedExecution = /** @class */ (function () {
    function BearPreparedExecution(authCall, definition, executionFactory) {
        this.authCall = authCall;
        this.definition = definition;
        this.executionFactory = executionFactory;
    }
    BearPreparedExecution.prototype.execute = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var afmExecution;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                afmExecution = ExecutionConverter_1.toAfmExecution(this.definition);
                return [2 /*return*/, this.authCall(function (sdk) {
                        return sdk.execution
                            .getExecutionResponse(_this.definition.workspace, afmExecution)
                            .then(function (response) {
                            return new executionResult_1.BearExecutionResult(_this.authCall, _this.definition, _this.executionFactory, response);
                        });
                    }, errorHandling_1.convertExecutionApiError)];
            });
        });
    };
    BearPreparedExecution.prototype.explain = function () {
        console.warn("Backend does not support explain mode");
        return {
            data: function () { return Promise.reject(new Error("Backend does not support explain mode data call.")); },
            download: function () { return Promise.resolve(); },
        };
    };
    BearPreparedExecution.prototype.withDimensions = function () {
        var dimsOrGen = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            dimsOrGen[_i] = arguments[_i];
        }
        return this.executionFactory.forDefinition(sdk_model_1.defWithDimensions.apply(void 0, tslib_1.__spreadArrays([this.definition], dimsOrGen)));
    };
    BearPreparedExecution.prototype.withSorting = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        return this.executionFactory.forDefinition(sdk_model_1.defWithSorting(this.definition, items));
    };
    BearPreparedExecution.prototype.withDateFormat = function (dateFormat) {
        return this.executionFactory.forDefinition(sdk_model_1.defWithDateFormat(this.definition, dateFormat));
    };
    BearPreparedExecution.prototype.withExecConfig = function (config) {
        if (!isEmpty_1.default(config === null || config === void 0 ? void 0 : config.dataSamplingPercentage)) {
            console.warn("Backend does not support data sampling, result will be not affected");
        }
        return this.executionFactory.forDefinition(this.definition);
    };
    BearPreparedExecution.prototype.fingerprint = function () {
        if (!this._fingerprint) {
            this._fingerprint = sdk_model_1.defFingerprint(this.definition);
        }
        return this._fingerprint;
    };
    BearPreparedExecution.prototype.equals = function (other) {
        return isEqual_1.default(this.definition, other.definition);
    };
    return BearPreparedExecution;
}());
exports.BearPreparedExecution = BearPreparedExecution;
//# sourceMappingURL=preparedExecution.js.map